import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import PlaceHolder from '../../portal/common/PlaceHolder';
const HtmlWidget = ({ text, editData, limitToPageWidth }) => {
    if (!(text && text.length) && editData) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure HTML Widget" }));
    }
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsx("div", { 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: { __html: text } }) }));
};
HtmlWidget.meta = {
    group: 'design',
    name: 'HTML',
    sort: 80,
    description: 'Directly render HTML content.',
    props: [
        {
            key: 'text',
            name: 'Text',
            type: 'textArea', // note this is a special type recognized by the system
            description: 'The raw HTML to display.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'HtmlWidget',
        props: {
            limitToPageWidth: true,
        },
    },
};
export default HtmlWidget;
//# sourceMappingURL=HtmlWidget.js.map